// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"25c88da9","113":"ebcf67c1","407":"78efe788","453":"54292a4b","686":"d5330c89","704":"0facd058","720":"28a37f49","842":"a9a3d89a","865":"af903ecb"}[chunkId] + ".chunk.js";
};